<template>
	<el-row>
		<el-button @click="add">添加圈文素材</el-button>
		<el-row>
			<el-col>
				<span>分类名称</span>
				<el-cascader v-model="value" :options="scOptions" :props="datagz2" style="margin: 0 10px; width: 300px">
				</el-cascader>
				<span>文本内容</span>
				<el-input v-model="matInfo" style="margin: 0 10px; width: 300px"></el-input>
				<el-button @click="screen()" type="primary">筛选</el-button>
				<el-button @click="exportCircle()">导出Excel</el-button>
				<el-button @click="zhikong" type="success">置空</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="素材id" width="100px" prop="matId"></el-table-column>
					<el-table-column label="素材图片">
						<template slot-scope="scope">
							<video v-if="scope.row.matImg2[0].substring(scope.row.matImg2[0].length - 4) == '.mp4'"
								:src="scope.row.matImg2[0]" style="width: 100px; height: 100px"></video>
							<el-image v-if="scope.row.matImg2[0].substring(scope.row.matImg2[0].length - 4) != '.mp4'"
								:src="scope.row.matImg2[0]" :preview-src-list="scope.row.matImg2"
								style="width: 100px; height: 100px"></el-image>
						</template>
					</el-table-column>
					<!-- <el-table-column label="分类" prop="courseCategoryName"></el-table-column> -->
					<el-table-column label="素材文案" prop="matInfo"> </el-table-column>
					<el-table-column label="素材目录" prop="libraryName"> </el-table-column>
					<!-- <el-table-column label="素材类型" prop="myStyleName"></el-table-column> -->
					<el-table-column label="关联商品id" prop="productId"></el-table-column>
					<!-- <el-table-column label="应用场景" prop="matApplicationName"></el-table-column> -->
					<!-- <el-table-column label="代理人设" prop="arr"></el-table-column> -->
					<el-table-column label="状态">
						<template slot-scope="scope">
							{{ scope.row.useStatus == 1 ? "下架" : "上架" }}
						</template>
					</el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="isStatus(scope.row)">
								{{ scope.row.useStatus == 0 ? "下架" : "上架" }}
							</el-button>
							<el-button @click="editorCircle(scope.row)" type="text">编辑
							</el-button>
							<el-button @click="delCircle(scope.row)" type="text">
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto; width: 1000px;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30, 60, 100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="dialogVisible" center>
			<el-form :model="info" ref="info" label-position="right" label-width="100px">
				<!-- <el-form-item label="分类" prop="arr" :rules="[{
					required: true, message: '请选择分类', trigger: 'change'
				}]">
					<el-cascader v-model="info.arr" :options="options" :props="props" @change="visibleChange"
						style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="商品款式" prop="productId" :rules="[{
					required: true, message: '请选择商品款式', trigger: 'change'
				}]">
					<el-select v-model="info.productId" placeholder="可选择可输入" filterable>
						<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<div style="color:burlywood;">请先选择分类，根据分类选择款式</div>
				</el-form-item> -->
				<el-form-item label="素材分类" prop="sucaiId" :rules="[{
					required: true, message: '请选择素材分类', trigger: 'change',
				}]">
					<el-cascader v-model="info.sucaiId" :options="scOptions" :props="datagz2" @change="handleChange"
						style="width: 300px;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="商品id">
					<el-input v-model="info.matNote" type="number" style="width: 250px;"></el-input>
				</el-form-item>
				<!--  prop="matInfo" :rules="[{
					required: true, message: '请输入素材文案', trigger: 'change'
				}]" -->
				<el-form-item label="素材文案">
					<el-input v-model="info.matInfo" type="textarea"></el-input>
				</el-form-item>
				<el-form-item label="素材图片" prop="matImg" :rules="[{
					required: true, message: '请上传素材图片', trigger: 'change'
				}]">
					<el-select @change="chooseType" v-model="urlType" placeholder="请选择类型" style="margin-bottom: 10px;">
						<el-option v-for="item in urlTypeoptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<div v-if="urlType == 0">
						<!-- <el-radio-group v-model="radioValue" @input="chooseRadio">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group> -->
						<el-button @click="open()" type="primary" style="margin-bottom: 10px;"
							v-if="fileList.length < 9">
							上传图片
						</el-button>
						<el-upload class="hide" action="" list-type="picture-card" :file-list="fileList"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" v-if="fileList.length > 0">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<div>图片最多上传9张</div>
					</div>
					<div v-if="urlType == 1">
						<el-upload :class="{ hide: hideUpload }"
							action="https://pro.xinian727.com/api/product/common/uploadQunce" list-type="picture-card"
							:limit="9" accept=".mp4" :on-success="getPictrueURL" v-if="info.matImg == ''">
							<i class="el-icon-plus" />
						</el-upload>
						<div v-else>
							<video :src="info.matImg" width="300px" height="200px" controls></video>
							<el-button @click="info.matImg = ''" icon="el-icon-delete" type="mini"></el-button>
						</div>
						<span>视频最多上传一条，mp4格式</span>
					</div>
					<!-- <el-button @click="openImg()" type="text">图片库上传</el-button> -->
				</el-form-item>
				<!-- <el-form-item label="素材类型" prop="matStyle" :rules="[{
					required: true, message: '请选择商品款式', trigger: 'change'
				}]">
					<el-select v-model="info.matStyle">
						<el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item> -->
				<!-- <el-form-item label="应用场景" prop="matApplication" :rules="[{
					required: true, message: '请选择应用场景', trigger: 'change'
				}]">
					<el-select v-model="info.matApplication">
						<el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="代理人设" prop="matPersona" :rules="[{
					required: true, message: '请选择代理人设', trigger: 'change',
				}]">
					<el-cascader v-model="info.matPersona" :options="options5" :props="props2" clearable
						style="width: 100%;">
					</el-cascader>
				</el-form-item> -->
				<!-- 	<el-form-item label="备注">
					<el-input v-model="info.matNote"></el-input>
				</el-form-item> -->
				<el-form-item>
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sumbit"> 确 定 </el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer title="选择图片" :visible.sync="isSelectPicture" direction="rtl" size="40%">
			<SelectPicture :key="timer" :imgNum="imgNum" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				timer: '',
				radioValue: 0,
				scOptions: [],
				datagz2: {
					'value': 'id',
					'label': 'name',
					'children': 'childList',
				},
				imgNum: 9,
				isSelectPicture: false,
				isShow: true,
				urlType: 0,
				urlTypeoptions: [{
					value: 0,
					label: '图片'
				}, {
					value: 1,
					label: '视频',
				}],
				value: [],
				matInfo: '',
				options: [],
				options2: [],
				options3: [],
				options4: [],
				options5: [],
				props: {
					value: "id",
					label: "name",
					children: "sonList",
				},
				props2: {
					value: "id",
					label: "name",
					multiple: true,
				},
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				title: "",
				dialogVisible: false,
				dialogImageUrl: "",
				dialogDisplay: false,
				hideUpload: false,
				fileList: [],
				info: {
					sucaiId: '',
					matId: '',
					arr: [],
					categoryId: "",
					productId: "",
					matInfo: "",
					matImg: "",
					matStyle: "",
					matApplication: "",
					matPersona: "",
					memberId: "",
					matNote: "",
				},
			};
		},
		methods: {
			chooseRadio() {
				if (this.radioValue == 1) {
					this.isSelectPicture = true
				}
			},
			handleChange(val) {
				console.log(val);
				this.info.sucaiId = val
			},
			openImg(num) {
				this.isSelectPicture = true
				this.imgNum = 9

			},
			open() {
				this.isSelectPicture = true
				this.imgNum = 9
				this.timer = new Date().getTime()
			},
			getImg(e) {
				this.info.matImg = e
				if (this.urlType == 0) {
					this.fileList = []
					e.split(',').forEach(item => {
						this.fileList.push({
							url: item
						})
					})
				}
				this.isSelectPicture = false
			},
			chooseType() {
				console.log(this.urlType, this.info.matImg);
				this.info.matImg = ''
				this.fileList = []
			},
			delVideo() {
				this.dialogImageUrl = ''
				this.hideUpload = false
				this.isShow = true
			},
			screen() {
				this.getInfo()
			},
			zhikong() {
				this.value = []
				this.matInfo = ''
				this.getInfo()
			},
			exportCircle() {
				let primaryType = null
				let secondary = null
				if (this.value.length > 0) {
					primaryType = arr[0]
					secondary = arr[1]
				}
				this.$http.post('/api/statistics/knowledgeBase/exportKnowledgeBase', {
					"id": null, //ID
					"primaryType": primaryType, //一级品类编号
					"secondary": secondary, //二级品类编号
					"salesCrowd": "", //销售人群
					"commodityStyle": "" //商品款式
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出圈文素材表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '圈文素材列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			isStatus(row) {
				console.log(row.useStatus);
				let title = "";
				if (row.useStatus == 0) {
					title = "下架";
				} else {
					title = "上架";
				}
				this.$confirm("此操作将改变状态, 是否继续?", title + "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$http
							.post("/api/plant/groupMaterial/deleteMaterial", {
								matId: row.matId,
								useStatus: row.useStatus == 0 ? 1 : 0,
							})
							.then((res) => {
								console.log(res.data.data);
								if (res.data.status == 0) {
									this.$message.success(title + "成功");
									this.getInfo();
								} else {
									this.$message.error(title + "失败");
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			sumbit() {
				console.log(this.info);
				// return false
				this.$refs.info.validate((valid) => {
					if (valid) {
						// if (this.info.arr.length > 0) {
						// 	this.info.categoryId = this.info.arr[1];
						// }
						// let matPersona = [];
						// if (this.info.matPersona.length > 0) {
						// 	this.info.matPersona.forEach((i) => {
						// 		matPersona.push(i[0]);
						// 	});
						// }
						// console.log(this.info.matPersona);
						// console.log(matPersona);
						// return false
						if (this.title == '添加圈文素材') {
							this.$http.post("/api/plant/groupMaterial/insertMaterial", {
								categoryId: '',
								libraryLevelOneId: this.info.sucaiId[0],
								libraryLevelThreeId: this.info.sucaiId[2],
								libraryLevelTwoId: this.info.sucaiId[1],
								matImg: this.info.matImg,
								matInfo: this.info.matInfo,
								matNote: '',
								memberId: this.$store.state.userInfo.id,
								productId: this.info.matNote,
								// matStyle: '',
								// matApplication: '',
								// matPersonaList: matPersona,
							}).then((res) => {
								console.log(res.data);
								if (res.data.status == "0") {
									this.$message.success('新增成功');
									this.dialogVisible = false;
									this.getInfo();
								} else {
									this.$message.error('新增失败');
								}
							});
						} else if (this.title == '编辑圈文素材') {
							this.$http.post("/api/plant/groupMaterial/updateMaterial", {
								matId: this.info.matId,
								categoryId: '',
								libraryLevelOneId: this.info.sucaiId[0],
								libraryLevelThreeId: this.info.sucaiId[2],
								libraryLevelTwoId: this.info.sucaiId[1],
								matImg: this.info.matImg,
								matInfo: this.info.matInfo,
								matNote: '',
								memberId: this.$store.state.userInfo.id,
								productId: this.info.matNote,
							}).then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('修改成功');
									this.dialogVisible = false;
									this.getInfo();
								} else {
									this.$message.error('修改失败');
								}
							});
						}
					}
				});
			},
			delCircle(row) {
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						this.$http.post("/api/plant/groupMaterial/deleteMaterial", {
								matId: row.matId,
								deleteStatus: 1,
							})
							.then((res) => {
								console.log(res.data.data);
								if (res.data.status == 0) {
									this.$message.success("删除成功");
									this.getInfo();
								} else {
									this.$message.error("删除失败");
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			add() {
				this.title = "添加圈文素材";
				this.dialogVisible = true;
				this.info = {
					sucaiId: '',
					arr: [],
					categoryId: "",
					productId: "",
					matInfo: "",
					matImg: "",
					matStyle: "",
					matApplication: "",
					matPersona: "",
					memberId: "",
					matNote: "",
				}
				this.hideUpload = false
				this.isShow = true
				this.fileList = []
			},
			editorCircle(row) {
				console.log(row);
				this.title = '编辑圈文素材'
				this.dialogVisible = true
				this.fileList = []
				if (row.matImg2.length > 0) {
					row.matImg2.forEach(item => {
						if (row.matImg2[0].substring(row.matImg2[0].length - 3) == 'mp4') {
							this.hideUpload = true
							this.urlType = 1
							this.info.matImg = row.matImg2[0]
						} else {
							this.urlType = 0
							this.fileList.push({
								url: item,
							})
							this.hideUpload = this.fileList.length >= 9
						}
					})
				}
				this.hideUpload = this.fileList.length >= 9
				// this.$http.get(`/api/product/productCategory/selectProductByCategoryId?categoryId=${row.categoryId}`, {})
				// 	.then((res) => {
				// 		if (res.data.data.length > 0) {
				// 			this.options2 = [];
				// 			res.data.data.forEach((item) => {
				// 				this.options2.push({
				// 					label: item.name,
				// 					value: item.id,
				// 				});
				// 			});
				// 		}
				// 	});
				this.info = {
					sucaiId: [row.libraryLevelOneId, row.libraryLevelTwoId, row.libraryLevelThreeId],
					matId: row.matId,
					arr: row.categoryId,
					categoryId: '',
					productId: row.productId,
					matInfo: row.matInfo,
					matImg: row.matImg,
					matStyle: row.matStyle,
					matApplication: row.matApplication,
					matPersona: row.arr2,
					memberId: "",
					matNote: row.productId,
				}
			},
			getInfo() {
				let libraryLevelOneId = ''
				let libraryLevelTwoId = ''
				let libraryLevelThreeId = ''
				if (this.value.length > 0) {
					libraryLevelOneId = this.value[0]
					libraryLevelThreeId = this.value[2]
					libraryLevelTwoId = this.value[1]
				} else {
					libraryLevelOneId = ''
					libraryLevelThreeId = ''
					libraryLevelTwoId = ''
				}
				this.$http.post("/api/plant/groupMaterial/selectMaterial", {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					categoryId: '',
					libraryLevelOneId: libraryLevelOneId,
					libraryLevelTwoId: libraryLevelTwoId,
					libraryLevelThreeId: libraryLevelThreeId,
					matInfo: this.matInfo
				}).then((res) => {
					console.log(res.data.data.list);
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(i => {
							i.matImg2 = [];
							i.matImg2 = i.matImg.split(",");
							// i.arr = [];
							// i.arr2 = [];
							// if (i.labelVos) {
							// 	i.labelVos.forEach((item) => {
							// 		i.arr.push(item.labelName);
							// 		i.arr2.push([item.labelId]);
							// 	});
							// }
							// i.arr = i.arr.join(",");
							// i.arr2 = i.arr2.join(",");
						});
					}
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size;
				//重新请求数据
				this.getInfo();
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage;
				//重新请求数据
				this.getInfo();
			},
			//获取分类
			getpaiCategory() {
				this.$http.get("/api/plant/plantManage/productPaiCategoryDrop", {}).then((res) => {
					console.log('分类', res.data);
					this.options = res.data.data;
				});
			},
			//根据分类选择商品
			visibleChange() {
				this.info.productId = ''
				if (this.info.arr.length > 0) {
					this.$http.get(
							`/api/product/productCategory/selectProductByCategoryId?categoryId=${this.info.arr[1]}`, {})
						.then((res) => {
							if (res.data.data.length > 0) {
								this.options2 = [];
								res.data.data.forEach((item) => {
									this.options2.push({
										label: item.name,
										value: item.id,
									});
								});
							}
						});
				}
			},
			//上传成功
			getPictrueURL(response, file, fileList) {
				if (response.status == 0) {
					// this.info.matImg = ''
					if (this.urlType == 0) {
						if (this.info.matImg[this.info.matImg.length - 1] == "") {
							this.info.matImg = response.data;
						} else {
							if (this.info.matImg.length > 0) {
								this.info.matImg += "," + response.data;
							} else {
								this.info.matImg = response.data;
							}
						}
						this.hideUpload = fileList.length >= 9;
					} else if (this.urlType == 1) {
						this.info.matImg = ''
						this.info.matImg = response.data;
					}
				} else {
					this.$message.error('上传失败')
				}
			},
			// 款式主图预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 款式主图上传框删除一个图片
			handleRemove(file, fileList) {
				let files = this.info.matImg.split(",");
				files.splice(files.indexOf(file.url), 1);
				this.info.matImg = files.length === 0 ? "" : files.join(",");
				this.fileList = fileList
				this.hideUpload = false;
			},
			// 款式主图预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			getInfo2() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=22`, {}).then((res) => {
					// console.log(res.data.data, "方向");
					if (res.data.data.length > 0) {
						res.data.data.forEach((i) => {
							this.options3.push({
								label: i.dicDesc,
								value: i.dicId,
							});
						});
					}
				});
			},
			getInfo3() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=33`, {}).then((res) => {
					// console.log(res.data.data, "方向");
					if (res.data.data.length > 0) {
						res.data.data.forEach((i) => {
							this.options4.push({
								label: i.dicDesc,
								value: i.dicId,
							});
						});
					}
				});
			},
			//获取销售人群
			getInfo4() {
				let arr = []
				this.$http.post("/api/plant/clrLabel/selectLabel", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					res.data.data.forEach((item) => {
						this.options5.push({
							id: item.memberLabelId,
							name: item.name,
						})
					})
				});
			},
			getFenl() {
				this.$http.post("/api/plant/groupMaterial/selectGroupLibrary", {}).then((res) => {
					console.log(res.data.data);
					this.scOptions = res.data.data
					// res.data.data.forEach((item) => {
					// 	this.options5.push({
					// 		id: item.memberLabelId,
					// 		name: item.name,
					// 	})
					// })
				});

			}
		},
		created() {
			this.getInfo();
			this.getInfo2();
			this.getInfo3();
			this.getInfo4();
			this.getpaiCategory();
			this.getFenl()
			console.log(this.$store.state.userInfo.id);
		},
	};
</script>

<style scoped>
	/deep/ .hide .el-upload--picture-card {
		display: none;
	}
</style>
